module.exports = __webpack_public_path__ + "img/99.7.201bc5f2.png";